export default "__VITE_ASSET__CgIC8Muo__"